module.exports = __webpack_public_path__ + "img/banner.b7ce4a13.jpg";